module.exports = __webpack_public_path__ + "static/media/success.daf0951b.png";